import { Button } from "antd";

const ThemeButtonV2 = ({
  content,
  className,
  onClick,
  bgColor,
  style,
  ...props
}) => {
  return (
    <Button
    onClick={onClick}
    type="primary"
    className={`${className} ${
      bgColor ? bgColor : "!bg-white"
    } h-9 font-semibold flex justify-center items-center text-primary border border-primary 
    hover:!text-white  hover:!bg-primary`}
    style={style}
    {...props}
  >
    {content}
  </Button>
  
  );
};

export default ThemeButtonV2;
